import React from "react";
import "./Footer.css";

const Footer = () => (
	<header className = "footer">
		<p>Clicky GAME</p>
	</header>
);

export default Footer;